import React from 'react';
import { getModelsForAgent, getDefaultModelForAgent } from '../../../constants/aiModels';
import './ModelSelect.css';

const ModelSelect = ({ aiAgent = 'claude', value, onChange, disabled = false, label }) => {
  const models = getModelsForAgent(aiAgent);
  const currentValue = value || getDefaultModelForAgent(aiAgent);

  return (
    <div className="model-select-wrapper">
      {label && <label className="model-select-label">{label}</label>}
      <select
        value={currentValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="model-select"
      >
        {models.map((m) => (
          <option key={m.id} value={m.id}>{m.name}</option>
        ))}
      </select>
    </div>
  );
};

export default ModelSelect;
